import { baseFetchToken } from './BaseSaga'
import BannerActions from '../Redux/BannerRedux'
import { getToken } from '../Services/GetToken'
// import { call, put } from 'redux-saga/effects'
// import AuthActions from '../Redux/AuthRedux'

export function * getBanners (api, action) {
  yield baseFetchToken(
    api.getBanners,
    action.data,
    getToken,
    BannerActions.bannerSuccess,
    BannerActions.bannerFailure)
}

export function * getBannerCustom (api, action) {
  yield baseFetchToken(
    api.getBannerCustom,
    action.data,
    getToken,
    BannerActions.bannerCustomSuccess,
    BannerActions.bannerCustomFailure
  )
}

export function * createBanner (api, action) {
  yield baseFetchToken(
    api.createBanner,
    action.data,
    getToken,
    BannerActions.bannerCreateSuccess,
    BannerActions.bannerCreateFailure)
}

export function * deleteBanner (api, action) {
  yield baseFetchToken(
    api.deleteBanner,
    action.data,
    getToken,
    BannerActions.bannerDeleteSuccess,
    BannerActions.bannerDeleteFailure)
}

export function * updateBanner (api, action) {
  yield baseFetchToken(
    api.updateBanner,
    action.data,
    getToken,
    BannerActions.bannerUpdateSuccess,
    BannerActions.bannerUpdateFailure)
}



// WEBPACK FOOTER //
// ./src/Sagas/BannerSagas.js